import FilesEvent from "../Entities/FilesEvent";

export {FilesEventManager as default};

/**
* Files Event Manager
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FilesEventManager {
  /**
   * Extracts all images from a js data transfer files arrays
   * and adds ir to a new FilesEvent object
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Array} files files object
   *
   * @return {FilesEvent}
   */
  static createImagesFilesEvent(files) {
    let images = new FilesEvent();

    if (!files[0]) {
      return images;
    }

    for (let k in files) {
      if (!files[k].type || !files[k].type.startsWith('image/')) {
        continue;
      }

      files[k].id = Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));
      images.items.push(files[k]);
      images.size += files[k].size;
    }

    return images;
  }

  /**
   * Extracts all files from a js data transfer files arrays
   * and adds ir to a new FilesEvent object
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Array} files files object
   *
   * @return {FilesEvent}
   */
  static createFilesEvent(files) {
    let event = new FilesEvent();

    if (!files[0]) {
      return event;
    }

    for (let k in files) {
      if (typeof files[k] !== 'object') {
        continue;
      }

      files[k].id = Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));
      event.items.push(files[k]);
      event.size += files[k].size;
    }

    return event;
  }
}